import { render, staticRenderFns } from "./skuForm.vue?vue&type=template&id=b523f4e2"
import script from "./skuForm.vue?vue&type=script&lang=js"
export * from "./skuForm.vue?vue&type=script&lang=js"
import style0 from "./skuForm.vue?vue&type=style&index=0&id=b523f4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports